import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getalluser, deleteuser } from "service/myapi";
import DeleteConfirmationModal from "./DeleteConfirmationModal"
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { getuserById, updateUser } from "service/api";
import { toast } from "react-toastify";


function DatatableTables() {
  const [alluserlist, setallusers] = useState([]);
  // const [alluserlist, setallusers] = useState({ users: [] });
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [selectedDeleteData, setSelectedDeleteData] = useState(null)
  const [token, setToken] = useState(null);
  const [clinicID, setclinicID] = useState(null);
  const [USERS, setUSERS] = useState([])
  const [USERS_update, setUSERS_update] = useState({
    name: "",
    email: "",
    mobile: "",
    staff_mobile: "",
    address: "",
    code: "",
    userType: "",
    dob: "",
    password: "",
    gender: "",
    clinic: "",
    empstatus: "",
    perslno: "",
    staffquli: "",
    povince: "",
    district: "",
    subdistrict: "",
    sancnumbe: "",
    hpsanumber: "",
    is_Guest_user: "",
  });

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await getuserById(id);
  //       const siteData = response.data;
  //       setUSERS(siteData);
  //     } catch (error) {
  //       console.error("Error fetching manufacturing site data:", error);
  //     }
  //   };

  //   fetchData();
  // }, [id]);


  // const updateMfrSitesDetails = async (e) => {
  //   e.preventDefault();
  //   try {
  //     await updateUser(id, USERS);
  //     Swal.fire({
  //       icon: 'success',
  //       title: 'Success!',
  //       text: 'Manufacturing site updated successfully!',
  //     }).then((result) => {
  //       if (result.isConfirmed || result.isDismissed) {
  //         navigate('/'); // Navigate to MFRSitesList page after successful update
  //       }
  //     });
  //   } catch (error) {
  //     console.error('Error updating manufacturing site:', error);
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error!',
  //       text: 'Failed to update manufacturing site.',
  //     });
  //   }
  // };

  const [updatingUsers, setUpdatingUsers] = useState({});


  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    setToken(storedToken);
    if (storedToken) {
      try {
        const decodedToken = jwtDecode(storedToken);
        setclinicID(decodedToken.clinicID);
      } catch (error) {
        console.error('Failed to decode token:', error);
      }
    }
    getallusers();
  }, []);

  useEffect(() => {
    if (clinicID) {
      getallusers();
    }
  }, [clinicID]);

  const getallusers = async () => {
    try {
      const response = await getalluser();
      console.log('Response Data:', response.data);
      if (response.error) {
        console.log('Error while fetching data:', response.error);
      } else {
        if (Array.isArray(response.data.users)) {
          const users = response.data.users;
          if (clinicID && clinicID.trim() !== '') {
            const filteredUsers = users.filter(user => user?.clinic && user?.clinic?._id === clinicID);
            setallusers(filteredUsers);
            console.log('Filtered Users:', filteredUsers);
          } else {
            setallusers(users);
            console.log('All Users:', users);
          }
        } else {
          console.error('Expected response.data.users to be an array but got:', response.data.users);
        }
      }
    } catch (error) {
      console.error('Failed to fetch users:', error);
    }
  };


  // const handleToggle = async (id) => {
  //   const newToggleState = !isToggled[id];
  //   setIsToggled((prevState) => ({
  //     ...prevState,
  //     [id]: newToggleState,
  //   }));

  //   try {
  //     await updateUser(id, { is_Guest_user: newToggleState ? 1 : 0 });
  //     console.log(`User ${id} is_Guest_user updated to ${newToggleState ? 1 : 0}`);
  //   } catch (error) {
  //     console.error(`Failed to update user ${id}:`, error);
  //   }
  // };

  const handleToggle = async (id, currentGuestStatus) => {
    const updatedGuestStatus = currentGuestStatus === 1 ? 0 : 1;
    const statusLabel = updatedGuestStatus === 0 ? "activated" : "deactivated";

    setUpdatingUsers((prevState) => ({
      ...prevState,
      [id]: true,
    }));

    try {
      await updateUser(id, { is_Guest_user: updatedGuestStatus });
      console.log(`User ${id} is_Guest_user updated to ${updatedGuestStatus}`);

      setallusers((prevState) =>
        prevState.map((user) =>
          user._id === id ? { ...user, is_Guest_user: updatedGuestStatus } : user
        )
      );

      toast.success(`User ${statusLabel} successfully.`, {
        position: "top-center",
        autoClose: 1500,
      });
    } catch (error) {
      console.error(`Failed to update user ${id}:`, error);
      toast.error("Failed to update user status.", {
        position: "top-center",
        autoClose: 1500,
      });
    } finally {
      setUpdatingUsers((prevState) => ({
        ...prevState,
        [id]: false,
      }));
    }
  };


  const openDeleteModal = rowData => {
    setSelectedDeleteData(rowData)
    setIsDeleteModalOpen(true)
  }

  const closeDeleteModal = () => {
    setSelectedDeleteData(null)
    setIsDeleteModalOpen(false)
  }
  const handleDelete = async () => {
    try {
      if (selectedDeleteData) {
        await deleteuser(selectedDeleteData);
        closeDeleteModal();
        getallusers();
      }
    } catch (error) {
      console.error(error)
    }
  }


  const columns = useMemo(
    () => [
      {
        Header: 'Practice Name',
        accessor: 'clinic.name',
      },
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Email',
        accessor: 'email'
      },
      {
        Header: 'Role',
        accessor: 'userType'
      },
      {
        Header: "Action",
        accessor: row => {
          const id = row?._id
          const isActive = row?.is_Guest_user === 0;
          const isUpdating = updatingUsers[id] || false;

          return (
            <>
              <button className="btn btn-danger mx-2"
                onClick={() => openDeleteModal(id)}
              > <i className="mdi mdi-trash-can font-size-15"></i> </button>
              <div className="d-inline-flex align-items-center gap-2 px-2 py-1 rounded-pill border bg-light">
                <span
                  className={`badge rounded-pill ${isActive ? "bg-success" : "bg-secondary"}`}
                  style={{ minWidth: "88px" }}
                >
                  {isUpdating ? "Updating..." : isActive ? "Active" : "Deactivated"}
                </span>
                <label className="switch mb-0" style={{ opacity: isUpdating ? 0.7 : 1, cursor: isUpdating ? "not-allowed" : "pointer" }}>
                  <input
                    type="checkbox"
                    checked={isActive}
                    disabled={isUpdating}
                    onChange={() => handleToggle(id, row?.is_Guest_user)}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </>
          )
        },
      },
    ],
    [updatingUsers]
  );
  //meta title
  document.title = "Users | List";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="page-title"></h1>
          <Link to="/AddUser" className="btn btn-primary">ADD NEW USER</Link>
        </div>
        <Breadcrumbs title="Setting" breadcrumbItem="Users" />
        <TableContainer
          columns={columns}
          // data={alluserlist.users}
          data={Array.isArray(alluserlist) && alluserlist.length > 0 ? alluserlist : USERS}
          isGlobalFilter={true}
          isAddOptions={false}
          customPageSize={10}
          className="custom-header-css"
        />
        <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDelete}
        />
      </div>
    </div>
  );
}

export default DatatableTables;
